import { render } from "./TikTokFollowers.vue?vue&type=template&id=742bd397&scoped=true&ts=true"
import script from "./TikTokFollowers.vue?vue&type=script&lang=ts"
export * from "./TikTokFollowers.vue?vue&type=script&lang=ts"

import "./TikTokFollowers.vue?vue&type=style&index=0&id=742bd397&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742bd397"]])

export default __exports__